import { useAppSelector } from "../../../redux/store";
import { useOutletContext } from "react-router-dom";
import { OutletContext } from "../../router";
import { MessageLoader } from "./message.loader";
import { MessageSections } from "../../../pages/components/message/message";
import { Content, MainContentContainer } from "../../styled";
import { Sidebar } from "../../../pages/sidebar";
import { globalHeaderRef } from "../../../pages/shared/refs";
import { Footer } from "../../../pages/footer/footer";
import React from "react";
import { CustomerView } from "../../../management-pages/user-order-management/blocks/user-management-view/customer-view";
import CustomerOrder
    from "../../../management-pages/user-order-management/blocks/user-management-view/customer-blocks/customer-order";
import DashboardPage from "../../../management-pages/dashboard";
import {
    actionsColumn,
    addressColumn,
    addressLine2Column,
    balanceColumn,
    cityColumn,
    emailColumn,
    messageKey,
    messageName,
    messageSection,
    nameColumn,
    provinceCountry,
    registeredDateColumn,
    totalCountColumn,
    totalPaymentsColumn,
    totalWeightColumn,
    userStatusColumn,
    warehouseAddress,
    warehouseCity,
    warehouseColumn,
    warehouseCountry,
    warehouseName,
    warehousePhone,
    userPhoneColumn,
    orderMobileStatusColumn,
    numberOfParcelsColumn,
    orderActionsColumn,
    zipCodeColumn
} from "../../../management-pages/shared/model/customers-table-column.model";
import ordersService from "../../../services/orders.service";
import warehousesService from "../../../services/warehouses.service";
import { WarehouseWorkersView } from "../../../management-pages/user-order-management/blocks/user-management-view/warehouse-workers-view";
import { WarehouseView } from "../../../management-pages/user-order-management/blocks/user-management-view/warehouse-view";
import {
    ManagementDataContainer,
    ManagementPageType
} from "../../../management-pages/user-order-management/management-data-container";
import UserManagementLoader from "../../../management-pages/user-order-management/user-management-loader";
import allUsersService from "../../../services/all-users.service";
import { ManagementActionBar } from "../../../management-pages/user-order-management/blocks/management-action-bar";
import AllOrders
    from "../../../management-pages/user-order-management/blocks/user-management-view/customer-blocks/all-orders";
import messagesService from "../../../services/messages.service";
import { StaticDataManagement } from "../../../management-pages/static-value-management/static-data-management";
import { HistoryManagement } from "../../../management-pages/history-management/history-management";
import { Settings } from "../../../pages/user/settings/settings";
import Calculate from "../../../pages/calculate";
import { TabType } from "../../../management-pages/shared/enums";
import mobileService from "../../../services/mobile-users";

export const AdminRoutes = {
    path: 'management',
    Component: () => {
        const { isOpen } = useAppSelector(state => state.sidebarReducer);
        const { matchesTablet, matchesPc } = useAppSelector(state => state.deviceReducer);

        const outletContext = useOutletContext<OutletContext>();

        return (
            <MessageLoader key={MessageSections.ORDERS} sectionName={MessageSections.ORDERS}>
                <MessageLoader key={MessageSections.USER} sectionName={MessageSections.USER}>
                    <MainContentContainer id={'main-content-container'}>
                        <Sidebar headerRef={globalHeaderRef} />
                        <Content
                            style={{
                                paddingLeft: isOpen
                                    && (matchesTablet || matchesPc) ? '15rem' : 'unset'
                            }}>
                            <UserManagementLoader context={outletContext} />

                            <Footer />
                        </Content>
                    </MainContentContainer>
                </MessageLoader>
            </MessageLoader>
        )
    },
    children: [
        {
            path: 'dashboard',
            index: true,
            Component: () => <DashboardPage />
        },
        {
            path: 'customers',
            Component: () => {
                const columns = [
                    nameColumn,
                    provinceCountry,
                    addressLine2Column,
                    totalCountColumn,
                    totalWeightColumn,
                    totalPaymentsColumn,
                    balanceColumn,
                    emailColumn,
                    registeredDateColumn,
                    userStatusColumn,
                    actionsColumn
                ];

                return <ManagementDataContainer columns={columns}
                    defaultFilter={{ userGroup: 3 }}
                    actionbarMessageKey={'customers'}
                    type={ManagementPageType.CUSTOMERS}
                    searchFunction={ordersService.collectOrdersGroupedByUser} />
            }
        },
        {
            path: 'warehouse-workers',
            Component: () => {
                const columns = [
                    nameColumn,
                    cityColumn,
                    warehouseColumn,
                    registeredDateColumn,
                    userStatusColumn,
                    actionsColumn
                ];

                return <ManagementDataContainer columns={columns}
                    defaultFilter={{ userGroup: [4, 2] }}
                    actionbarMessageKey={'warehouse_workers'}
                    type={ManagementPageType.WAREHOUSE_WORKERS}
                    searchFunction={allUsersService.getAllUsers} />
            }
        },
        {
            path: 'all-orders',
            children: [
                {
                    path: '',
                    index: true,
                    Component: () => {
                        return (
                            <>
                                <ManagementActionBar actionbarMessageKey={'all_orders'} type={ManagementPageType.ALL_ORDERS} />
                                <AllOrders />
                            </>
                        )
                    }
                },
                {
                    path: 'order/:orderId',
                    Component: () => {
                        return <CustomerOrder />;
                    }
                }
            ]
        },
        {
            path: 'customer/:customerId',
            children: [
                {
                    path: 'account',
                    index: true,
                    Component: () => {
                        return <CustomerView />;
                    }
                },
                {
                    path: 'order/:orderId',
                    Component: () => {
                        return <CustomerOrder />;
                    }
                }
            ]
        },
        {
            path: 'warehouses',
            Component: () => {

                const columns = [
                    warehouseName,
                    warehouseCity,
                    warehouseCountry,
                    warehouseAddress,
                    warehousePhone,
                ];

                return <ManagementDataContainer columns={columns}
                    defaultFilter={{}}
                    actionbarMessageKey={'warehouses'}
                    type={ManagementPageType.WAREHOUSES}
                    searchFunction={(filter, limit, page) => warehousesService.getWarehouses((page || 0), limit)} />
            }
        },
        {
            path: 'warehouse',
            children: [
                {
                    path: ':warehouseId',
                    children: [
                        {
                            path: '',
                            index: true,
                            Component: () => {
                                return <WarehouseView />;
                            }
                        },
                    ]
                },
                {
                    path: 'worker/:warehouseWorkerId',
                    children: [
                        {
                            path: 'account',
                            Component: () => {
                                return <WarehouseWorkersView />;
                            }
                        }
                    ]
                },
            ]
        },
        {
            path: 'messages',
            children: [
                {
                    path: '',
                    index: true,
                    Component: () => {
                        const columns = [
                            messageKey,
                            messageName,
                            messageSection,
                            actionsColumn
                        ];

                        return (
                            <ManagementDataContainer 
                                columns={columns}
                                defaultFilter={{}}
                                actionbarMessageKey={'messages'}
                                type={ManagementPageType.MESSAGES}
                                searchFunction={messagesService.getAllMessages} 
                                staticDataType={TabType.MESSAGES}
                                />
                        )
                    }
                }
            ]
        },
        {
            path: 'static-values',
            children: [
                {
                    path: '',
                    index: true,
                    Component: () => {
                        return (
                            <StaticDataManagement />
                        )
                    }
                }
            ]
        },
        {
            path: 'history',
            children: [
                {
                    path: '',
                    index: true,
                    Component: () => {
                        return (
                            <HistoryManagement />
                        )
                    }
                }
            ]
        },
        {
            path: 'user',
            children: [
                {
                    path: 'settings',
                    index: true,
                    Component: () => {
                        const outletContext = useOutletContext<OutletContext>();
                        return <Settings hasValidatedRecipient={outletContext.hasValidatedRecipient} />;
                    }
                }
            ]
        },
        {
            path: 'calculate',
            element:
                <MessageLoader key={MessageSections.CALCULATE} sectionName={MessageSections.CALCULATE}>
                    <Calculate />
                </MessageLoader>
        },
        {
            path: 'pdr/orders',
              Component: () => {
                const columns = [
                  nameColumn,
                  provinceCountry,
                  cityColumn,
                  zipCodeColumn,
                  addressColumn,
                  userPhoneColumn,
                  emailColumn,
                  numberOfParcelsColumn,
                  totalWeightColumn,
                  totalCountColumn,
                  registeredDateColumn,
                  orderMobileStatusColumn,
                  orderActionsColumn
                ];
            
                return <ManagementDataContainer columns={columns}
                  defaultFilter={{ userGroup: 3 }}
                  actionbarMessageKey={'orders'}
                  type={ManagementPageType.MOBILE_ORDERS}
                  searchFunction={mobileService.getMobileOrders} />
              }
        },
        {
            path: 'pdr/users',
              Component: () => {
                const columns = [
                    nameColumn,
                    provinceCountry,
                    addressColumn,
                    userPhoneColumn,
                    totalCountColumn,
                    emailColumn,
                    registeredDateColumn,
                ];
            
                return <ManagementDataContainer columns={columns}
                  defaultFilter={{ userGroup: 3 }}
                  actionbarMessageKey={'customers'}
                  type={ManagementPageType.MOBILE_USER}
                  searchFunction={mobileService.getMobileUsers} />
              }
        }
    ]
}